/**
 * A CAMADA DO TOUR — o único ponto montado no Router.
 *
 * Cada frente mora no seu arquivo (anfitrião do tour, Ajuda, dicas com ponto
 * pulsando, aviso de mudança). O Router não muda quando uma frente cresce.
 */
import type { ReactElement } from 'react'
import { AjudaDoTour } from './AjudaDoTour'
import { AvisoDeMudancaHost } from './AvisoDeMudancaHost'
import { DicasHost } from './DicasHost'
import { GuidedTourHost } from './GuidedTourHost'

export function GuidedTourLayer(): ReactElement {
  return (
    <>
      <GuidedTourHost />
      <DicasHost />
      <AvisoDeMudancaHost />
      <AjudaDoTour />
    </>
  )
}
